import { render, staticRenderFns } from "./EmmaInformationFlow.vue?vue&type=template&id=123b3757&"
import script from "./EmmaInformationFlow.vue?vue&type=script&lang=ts&"
export * from "./EmmaInformationFlow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports